import { OrderedMap } from 'immutable';
import { constants } from '@saucelabs/sl-module-root-cause';

export const FAILURE_ANALYSIS_PAGE_TITLE = 'Failure Analysis';
export const FAILURE_ANALYSIS_BASE_URL = '/analytics/test-patterns';

export const FAILURE_ANALYSIS_PAGE_TESTS_HEADER = 'Tests';
export const FAILURE_ANALYSIS_PAGE_TESTS_TAB_NAME = 'tests';
export const FAILURE_ANALYSIS_PAGE_TESTS_TAB_URL = `${FAILURE_ANALYSIS_BASE_URL}/${FAILURE_ANALYSIS_PAGE_TESTS_TAB_NAME}`;

export const FAILURE_ANALYSIS_PAGE_ROOT_CAUSES_URL = `${FAILURE_ANALYSIS_BASE_URL}/${constants.FAILURE_ANALYSIS_PAGE_ROOT_CAUSES_TAB_NAME}`;

export const FAILURE_ANALYSIS_PAGE_TESTS_TABLE_HEADERS = OrderedMap({
  test: 'Test Name',
  count: 'Total Failed Tests',
});

export const FAILURE_ANALYSIS_PAGE_TESTS_ROW_TABLE_HEADERS = OrderedMap({
  'root-causes': 'Failure Patterns',
  occurance: 'Sub-Totals',
});

export const ROOT_CAUSES_API_SUFFIX = '/root-causes/';
export const ROOT_CAUSES_OPTIMIZED_API_SUFFIX = '/root-causes-optimized/';
